
export default {
    MIN_TIME_IN_MILIS: 1000,
    MAX_TIME_IN_MILIS: 3600000,
    INACTIVITY_TIME_IN_MILIS: 1800000,
}
